import _extends from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _defineProperty from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import { styled } from '@mui/material/styles';
import Container from '@mui/material/Container';
import { jsx as _jsx } from "react/jsx-runtime";
var StyledAppContainer = styled(Container)(function (_ref) {
  var theme = _ref.theme;
  return _defineProperty({
    paddingTop: "calc(var(--MuiDocs-header-height) + ".concat(theme.spacing(4), ")"),
    // We're mostly hosting text content so max-width by px does not make sense considering font-size is system-adjustable.
    // 105ch ≈ 930px
    fontFamily: 'Arial',
    maxWidth: '105ch'
  }, theme.breakpoints.up('lg'), {
    paddingLeft: theme.spacing(8),
    paddingRight: theme.spacing(8)
  });
});
export default function AppContainer(props) {
  return /*#__PURE__*/_jsx(StyledAppContainer, _extends({
    id: "main-content",
    maxWidth: false
  }, props));
}